<template>
  <v-app id="inspire" class="gradient-color">
    <v-main class="pl-8 gradient-color">
      <v-container fluid>
        <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
          <v-card class="px-4 pt-4">
            <v-card-title>
              Recuperar senha
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="isFormValid" lazy-validation @submit.prevent="submit">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="email"
                      :rules="formRules.emailRules"
                      label="Email"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="password"
                      :rules="formRules.passwordRules"
                      label="Nova senha"
                      required
                      hide-details="auto"
                      :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show_password ? 'text' : 'password'"
                      @click:append="show_password = !show_password"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="password_confirmation"
                          :rules="[passwordConfirmationRule]"
                          label="Confirmar nova de senha"
                          required
                          hide-details="auto"
                          :append-icon="show_password_confirmation ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show_password_confirmation = !show_password_confirmation"
                          :type="show_password_confirmation ? 'text' : 'password'"
                        ></v-text-field>
                  </v-col>
                  
                  <v-spacer></v-spacer>
                  <v-col class="d-flex" cols="6" md="6" sm="6">
                  </v-col>
                  <v-col class="d-flex" cols="6" md="6" sm="6" align-end>
                    <v-btn 
                      large block 
                      outlined
                      color="#0dc4b8" 
                      type="submit"
                      @click="submit"
                      :disabled="isLoading"
                      :loading="isLoading"
                    > 
                      ALTERAR SENHA
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
      <Snackbar />
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
import Snackbar from '@/components/Snackbar'
import AuthService from '../services/auth.service.js';

export default {
  name: 'PasswordReset',
  components: {
    Snackbar,
  },
  data: () => ({
    dialog: true,
    email: null,
    formRules: {
      emailRules: [
        v => !!v || 'Email é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      passwordRules: [
        v => !!v || 'Senha é obrigatória',
      ],
    },
    isFormValid: true,
    isLoading: false,
    password: null,
    password_confirmation: null,
    show_password: false,
    show_password_confirmation: false,
    token: null,
  }),
  computed: {
    passwordConfirmationRule() {
      return () => (this.password === this.password_confirmation) || 'Confirmação da nova senha incorreta'
    }
  },
  mounted () { 
    this.token = this.$route.query.token;
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    submit () {
      if (!this.token) {
        this.showSnackbar({ text: "Token de recuperação de senha não informado!", color:"error" })
        return
      } else if(this.$refs.form.validate()) {
        this.isLoading = true;
         
        let data = { 
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.token
        };

        AuthService.resetPassword(data)
          .then(() => {
            this.showSnackbar({ text: "Senha alterada com sucesso!", color:"success" });
            this.$router.push('/login');
          })
          .catch(() => {
            this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" })
          })
          .finally(() => setTimeout(() => { this.isLoading = false; this.forgottenPasswordDialog = false; }, 300));

      }
    },
  }
};
</script>
